import styles from "./main-app-menu.module.css";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";

interface UserContentProps {
  didClickOption: () => void;
}

export const ContentUser = (props: UserContentProps) => {
  const { projectList, navigateTo } = usePaths();
  return (
    <div className={styles.userContent}>
      <MenuOption
        label="Projects"
        icon="FOLDER"
        onClick={() => {
          navigateTo(projectList);
          props.didClickOption();
        }}
      />
    </div>
  );
};
